import sortBy from 'lodash/fp/sortBy'
import type { Block } from 'shared/graphql/graphql'

export const getOrderedBlocks = (blocks: Block[], language: string) =>
  blocks
    ? sortBy(
        'order',
        blocks.filter((block) => block.language === language),
      )
    : []

export const separateBlocks = (blocks: Block[]) => {
  if (!blocks || blocks.length === 0) return { firstBlock: null, lastBlock: null, remainingBlocks: [] }
  if (blocks.length === 1) return { firstBlock: blocks[0], lastBlock: null, remainingBlocks: [] }

  const firstBlock = blocks[0]
  const lastBlock = blocks[blocks.length - 1]
  const remainingBlocks = blocks.slice(1, blocks.length - 1)

  return { firstBlock, lastBlock, remainingBlocks }
}

export const getTextFromHTML = (htmlString: string): string => {
  const parser = new DOMParser()
  const doc = parser.parseFromString(htmlString, 'text/html')

  return doc.body.textContent ?? ''
}
